import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import { SiteValuesApi } from "../api/AdminApi";
import { getData } from "../api/AuthenticatedApiCaller";
import SiteValuesAddDialog from "./SiteValuesAddDialog";

export default function SiteValuesView() {

    const [siteValues, setSiteValues] = useState(null)
    const [editedSiteValue, setEditedSiteValue] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [update, setUpdate] = useState(false);

    useEffect(() => {
        if (siteValues === null || update) {
            fetchData()
            setUpdate(false)
        }

    }, [update])


    async function fetchData() {
        const [data, error] = await getData(SiteValuesApi.getAllSiteValues);
        if (error) {
            // Handle the error
        } else {
            setSiteValues(data);
        }
    }

    return (
        <Box>
            {editedSiteValue !== null && (
                <SiteValuesAddDialog
                    open = {isDialogOpen}
                    value = {editedSiteValue}
                    save = {() =>{
                        setIsDialogOpen(false)
                        setUpdate(true)
                    }}
                    cancel={() => setIsDialogOpen(false)}
                />
            )}

            <Table sx={{ minWidth: 650 }} aria-label="site-setting-table">
                <TableHead>
                    <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Value</TableCell>
                        <TableCell>Edit</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {siteValues !== null && (
                        siteValues.map((value) => (
                            <TableRow id={value.id}>
                                <TableCell>{value.id}</TableCell>
                                <TableCell>{value.name}</TableCell>
                                <TableCell>{value.value}</TableCell>
                                <TableCell>
                                    <IconButton>
                                        <EditIcon
                                            onClick={() =>{
                                                setEditedSiteValue(value)
                                                setIsDialogOpen(true)
                                            }}
                                        />
                                    </IconButton>
                                </TableCell>

                            </TableRow>
                        ))

                    )}
                </TableBody>
            </Table>
        </Box>
    );
}